import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { AdminRequestDto, AdminResponseDto, AdminService, DeliveryOutputDto, DeliveryReceiptHeaderDto, DeliveryReceiptService, DeliveryService, OrderService } from 'src/generated_client';

@Component({
  selector: 'app-recibos-cadetes',
  templateUrl: './recibos-cadetes.component.html',
  styleUrls: ['./recibos-cadetes.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class RecibosCadetesComponent implements OnInit {

  displayedColumns: string[] = ['order', 'date', 'client', 'total', 'received', 'pending'];
  dataSource: any = []
  allDeliveries: DeliveryOutputDto[] = [];
  observaciones: string = '';
  total: number = 0;
  pending: number = 0;
  recibido: number = 0;
  saldo: number = 0;
  password: string = '';
  currentUser: AdminResponseDto = {};
  deliveryReceiptObj: DeliveryReceiptHeaderDto = {};

  receiptForm: FormGroup = this.fb.group({
    cadete: ['', Validators.required],
    date: [new Date()],
    receipt: [''],
    amount: ['', Validators.required],
  })

  constructor(
    public orderService: OrderService,
    public deliveryService: DeliveryService,
    public authService: AuthService,
    public adminService: AdminService,
    public snackBar: SnackBarService,
    public deliveryReceipt: DeliveryReceiptService,
    private fb: FormBuilder
  ) { }

  private toArray<T>(response: any): T[] {
    if (Array.isArray(response)) {
      return response;
    }

    const candidates = [response?.data, response?.items, response?.result, response?.values];
    const firstArray = candidates.find(Array.isArray);

    return firstArray ?? [];
  }

  ngOnInit() {
    this.deliveryService.apiDeliveryGetAllGet().subscribe(response => {
      this.allDeliveries = this.toArray<DeliveryOutputDto>(response);
    });
    this.deliveryReceipt.apiDeliveryReceiptGetUltimateReceiptNumberGet().subscribe(response => {
      this.receiptForm.controls['receipt'].setValue(response);
    })
  }

  search(form: any) {
    this.orderService.apiOrderGetOrdersForReceiptGet(form.cadete).subscribe(response => {
      this.total = 0;
      this.pending = 0;
      this.recibido = 0;
      this.saldo = 0;

      const orders = this.toArray<any>(response);
      this.dataSource = orders;

      orders.forEach(r => {
        this.total = this.total + r.qtTotal!;
        this.pending = this.pending + (r.qtTotal! - r.qtMontoRecibo!);
        this.recibido = this.recibido + r.qtMontoRecibo!;
        this.saldo = (this.receiptForm.get('amount')!.value - this.pending)
      })
    })
  }

  confirm() {
    this.currentUser = this.authService.currentUser();
    let confirm: AdminRequestDto = {
      dsPassword: this.password,
      dsUsername: this.currentUser.dsUsername!
    }
    this.adminService.apiAdminConfirmPost(confirm).subscribe(response => {
      this.deliveryReceiptObj = {
        cdDelivery: this.receiptForm.get('cadete')!.value,
        dsObservacion: this.observaciones,
        dtDate: this.receiptForm.get('date')!.value,
        nmReceiptNumber: this.receiptForm.get('receipt')!.value,
        qtSaldo: this.saldo,
        qtTotal: this.total
      }
      this.deliveryReceipt.apiDeliveryReceiptPostPost(this.deliveryReceiptObj).subscribe(response => {
        this.snackBar.openSnackBar('El recibo se generó correctamente.', 'Aceptar');
      }, error => {
        this.snackBar.openSnackBar(error.error.error, 'Aceptar')
      })
    }, error => {
      this.snackBar.openSnackBar('La contraseña es incorrecta.', 'Aceptar');
    })

  }
}